<template>
<v-container fluid grid-list-lg>
  <v-layout row wrap>
    <v-flex>
      <v-card>
        <v-card-title primary-title class="primary white--text headline">
          System Configuration Form
        </v-card-title>
        <v-card-text>
          <form>
            <v-layout row>
              <v-flex xs6>
                <v-text-field
                disabled
                v-model="item.id"
                label="ID">
                </v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                disabled
                v-model="item.name"
                label="Name">
                </v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row v-for="(configValue, configName) in item.config" :key=configName>
              <v-flex xs12>
                <v-text-field v-if="typeof item.config[configName] !== 'object'"
                v-model="item.config[configName]"
                :label=configName
                v-validate="'required'"
                :data-vv-name=configName
                :error-messages="errors.collect(configName)"
                required
                >
                </v-text-field>
                <div fluid v-if="typeof item.config[configName] === 'object'">
                  <v-subheader>
                    {{ configName }}
                  </v-subheader>
                  <v-layout row v-for="(subConfigValue, subConfigName) in item.config[configName]" :key=subConfigName>
                    <v-flex xs12>
                      <v-text-field
                      v-model="item.config[configName][subConfigName]"
                      :label=subConfigName
                      v-validate="'required'"
                      :data-vv-name=subConfigName
                      :error-messages="errors.collect(subConfigName)"
                      required
                      >
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                </div>

              </v-flex>
            </v-layout>
            <!-- <v-layout row>
              <v-flex xs12>
                <v-textarea
                  label="Text to analyse"
                  v-validate="'required'"
                  data-vv-name="text"
                  :error-messages="errors.collect('text')"
                  v-model="item.config"
                ></v-textarea>
              </v-flex>
            </v-layout> -->
          </form>
        </v-card-text>
        <v-card-actions style="background: hsl(0, 0%, 97%)" class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat depressed @click.native="cancel" :disabled="saveLoading">Cancel</v-btn>
          <v-btn color="accent" class="white--text" depressed @click.native="validateBeforeSubmit(save)" :loading="saveLoading" :disabled="saveLoading">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'system-configuration-item',
  props: {
    id: {
      type: String,
      required: false,
      default: ''
    }
  },
  created () {
    if (!this.isNew) {
      this.setLoader({
        loading: true
      })
      this.fetchSystemConfigurationItem()
    }
  },
  data () {
    return {
      item: {
        id: '',
        name: '',
        config: undefined
      },
      saveLoading: false,
      datasetCollection: [],
      topicModelCollection: [],
      annotationWorkCollection: [],
      sentimentModelCollection: []
    }
  },
  computed: {
    isNew () {
      return this.id == null || this.id === ''
    }
  },
  methods: {
    cancel () {
      this.$router.go(-1)
    },
    fetchSystemConfigurationItem () {
      this.axios.get(`/system-configurations/${this.id}`)
        .then(response => {
          this.setScheduledJobItem(response.data)
        })
        .catch(error => {
          this.handleAxiosError(error)
        })
        .finally(() => {
          this.setLoader({
            loading: false
          })
        })
    },
    setScheduledJobItem (item) {
      this.item = this.mapScheduledJobItem(item)
    },
    mapScheduledJobItem (item) {
      return {
        id: item.id,
        name: item.name,
        config: item.config
      }
    },
    save () {
      this.saveLoading = true
      let itemToSave = this.item

      if (this.isNew) {
        this.axios.post('/system-configurations', itemToSave)
          .then(response => {
            this.$router.go(-1)
          })
          .catch(error => {
            this.handleAxiosError(error)
          })
          .finally(() => {
            this.saveLoading = false
          })
      } else {
        this.axios.put(`/system-configurations/${this.item.id}`, itemToSave)
          .then(response => {
            this.$router.go(-1)
          })
          .catch(error => {
            this.handleAxiosError(error)
          })
          .finally(() => {
            this.saveLoading = false
          })
      }
    },
    fetchAnnotationWorks () {
      this.axios.get('/annotation-works', {
        params: {
          topic_model_id: this.item.topicModelId
        }
      }).then(response => {
        this.annotationWorkCollection = response.data.map((aw) => { return {text: aw.name, value: aw.id} })
      })
    },
    ...mapActions({
      setLoader: 'loader/setLoader'
    })
  },
  watch: {
    item: {
      deep: true,
      handler (newValue) {
        if (newValue.topicModelId) {
          this.fetchAnnotationWorks()
        }
      }
    }
  }
}
</script>

<style>

</style>
